import { IndicatorTypes } from '../../../../interfaces/IndicatorIndex'
import ResponsiveContainer from '../../../../layouts/ResponsiveContainer';
import { INDICATOR_TYPE_PROCESS, INDICATOR_TYPE_RESULTS, INDICATOR_TYPE_STRUCTURAL } from '../../../../utils/const';
import Section from './Sections';

const TYPE_ORDER = [INDICATOR_TYPE_STRUCTURAL, INDICATOR_TYPE_PROCESS, INDICATOR_TYPE_RESULTS] as const;

const Mapper = ({ currentIndicators, selectedLetter }: { currentIndicators: IndicatorTypes | null, selectedLetter: string }) => {
    return (
        <ResponsiveContainer>
            {currentIndicators && (
                <div className='mt-16'>
                    <div className='w-[4.75rem] border-b border-system-light-30 mb-5'>
                        <h2 className='text-dsmall text-system-light-100'>{selectedLetter}</h2>
                    </div>
                    {TYPE_ORDER.map((type) => (
                        <Section
                            key={`${selectedLetter}-${type}`}
                            type={type}
                            items={currentIndicators[type]}
                            letter={selectedLetter}
                        />
                    ))}
                </div>
            )}
        </ResponsiveContainer>
    )
}

export default Mapper